module.exports = "<div class=\"gw-breadcrumbs\" gw-partial=\"Item\"></div>\n"